module.exports = {"$schema":"http://json-schema.org/draft-04/schema#","title":"settings","link":"settings","$ref":"settingsPlusMemos","oneOf":[{"required":["memos"],"minProperties":2,"maxProperties":2},{"not":{"required":["memos"]},"minProperties":1,"maxProperties":1}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ripple-lib/dist/npm/common/schemas/specifications/settings.json
// module id = 8Kg1
// module chunks = 1